// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--2dy4m","loader":"dd31006766--loader--3qqJU"};